import { CbhIcon, type IconType, Text } from "@clipboard-health/ui-components";
import { Stack, type Theme } from "@mui/material";

interface AlertMessageProps {
  iconType: IconType;
  iconColor?: (theme: Theme) => string | undefined;
  title: string;
  titleColor?: (theme: Theme) => string | undefined;
  description?: string;
  descriptionVariant?: "body2" | "caption";
}

export function InlineAlert(props: AlertMessageProps) {
  const {
    iconType,
    iconColor,
    title,
    titleColor,
    description,
    descriptionVariant = "body2",
  } = props;

  return (
    <Stack direction="row" spacing={3} alignItems="flex-start">
      <CbhIcon type={iconType} size="medium" color={iconColor} />
      <Stack spacing={1} sx={{ flex: 1, paddingTop: 0.5 }}>
        <Text
          semibold
          variant="body1"
          sx={titleColor ? (theme) => ({ color: titleColor(theme) }) : undefined}
        >
          {title}
        </Text>
        {description && (
          <Text variant={descriptionVariant} sx={{ color: "text.secondary" }}>
            {description}
          </Text>
        )}
      </Stack>
    </Stack>
  );
}
